/**
 * Frances Design — DE Header Scroll Behaviour
 * Adds `is-scrolled` class to .de-header at 80px scroll.
 * Works alongside the existing fd-scroll-header.js for the
 * charcoal fade-in; this one drives the de- sections' header.
 */
(function () {
  'use strict';

  const header = document.querySelector('.de-header');
  if (!header) return;

  const THRESHOLD = 80;
  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {
    const scrolled = window.scrollY > THRESHOLD;
    header.classList.toggle('is-scrolled', scrolled);
    ticking = false;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update(); // set initial state
})();
